import { Route } from 'react-router-dom'

import { ReportsPage } from './ReportsPage'

export const routes = (
  <>
    <Route path="/analytics" element={<ReportsPage />} />
  </>
)
